export enum FilterType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  RANGE = 'range',
  DATERANGE = 'daterange'
}
